package com.devi3east.bashbuddy.prizeList.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.devi3east.bashbuddy.dashboard.ui.components.inputFields.NumberTextField
import com.devi3east.bashbuddy.features.common.util.DateTimeInput
import com.devi3east.bashbuddy.prizeList.domain.models.PrizeType
import com.devi3east.bashbuddy.prizeList.requests.CreatePrizeSeriesRequest
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant

@Composable
fun CreatePrizeSeriesFormDialog(
    eventStartInstant: Instant?,
    prizeType: PrizeType,
    onConfirm: (CreatePrizeSeriesRequest) -> Unit,
    onDismiss: () -> Unit
) {
    var count by remember { mutableStateOf("5") }
    var intervalMinutes by remember { mutableStateOf("5") }
    var startInstant by remember { mutableStateOf(eventStartInstant ?: Clock.System.now()) }

    AlertDialog(
        onDismissRequest = onDismiss,
        title = {
            Text(
                text = if (prizeType == PrizeType.MAIN_EVENT)
                    "Create Prize Series" else "Create Side Raffle Series",
                style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.SemiBold),
                modifier = Modifier.fillMaxWidth(),
                textAlign = TextAlign.Center
            )
        },
        text = {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .verticalScroll(rememberScrollState())
                    .padding(vertical = 8.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                NumberTextField(
                    label = "Number of Prizes",
                    value = count,
                    onValueChange = { count = it },
                    modifier = Modifier.fillMaxWidth()
                )
                DateTimeInput(
                    instant = startInstant,
                    onDateTimeChange = { newInstant -> startInstant = newInstant }
                )

                NumberTextField(
                    label = "Interval (minutes)",
                    value = intervalMinutes,
                    onValueChange = { intervalMinutes = it },
                    modifier = Modifier.fillMaxWidth()
                )
            }
        },
        confirmButton = {
            Button(
                onClick = {
                    val parsedCount = count.toIntOrNull() ?: 0
                    val parsedInterval = intervalMinutes.toIntOrNull() ?: 0
                    if (parsedCount > 0 && parsedInterval >= 0) {
                        onConfirm(
                            CreatePrizeSeriesRequest(
                                prizeType = prizeType,
                                count = parsedCount,
                                startInstant = startInstant,
                                intervalMinutes = parsedInterval
                            )
                        )
                        onDismiss()
                    }
                },
                colors = ButtonDefaults.buttonColors(
                    containerColor = MaterialTheme.colorScheme.primary,
                    contentColor = MaterialTheme.colorScheme.onPrimary
                ),
                shape = RoundedCornerShape(12.dp)
            ) {
                Text(
                    "Add",
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold)
                )
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text(
                    "Cancel",
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.SemiBold)
                )
            }
        },
        shape = RoundedCornerShape(24.dp),
        containerColor = MaterialTheme.colorScheme.surface,
        tonalElevation = 6.dp
    )
}